import "core-js/modules/es.array.slice.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/logos/square.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-197dc383"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "app-showcase"
};
var _hoisted_2 = {
  class: "d-none d-md-block"
};
var _hoisted_3 = {
  class: "row"
};
var _hoisted_4 = {
  class: "col"
};
var _hoisted_5 = {
  class: "d-flex flex-column h-100"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "panel-header px-4 py-2"
  }, "Standard user", -1);
});

var _hoisted_7 = {
  class: "col"
};
var _hoisted_8 = {
  class: "d-flex flex-column h-100 product-panel"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "panel-header px-4 py-2"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "product-header d-flex flex-row align-items-end"
  }, [/*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: _imports_0,
    class: "d-block square-logo"
  }), /*#__PURE__*/_createElementVNode("div", null, "Lucid user")])], -1);
});

var _hoisted_10 = {
  class: "d-block d-md-none"
};
var _hoisted_11 = {
  class: "text-center mb-2"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode("Switch mode to see the differences.");

import { ref, computed, onMounted } from "vue";
import { random } from "lodash";
import { DateTime } from "luxon/src/luxon";
import ShowcasePanel from "@/components/ShowcasePanel.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var maximum = 2;
    var rate = {
      min: 6000,
      max: 10000
    };
    var posts = ref([{
      user: {
        name: "Jane Taylor",
        avatar: "/images/ui/people/people-05.jpg"
      },
      message: {
        input: "car is moon on fire",
        clear: "I'll also be in town in the next few days! I just sent you a message"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Luka Simic",
        avatar: "/images/ui/people/people-07.jpg"
      },
      message: {
        input: "tower realm the desert",
        clear: "Did you already went to Sukiyabashi Jiro? Best Sushi in the world!"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Ivan Melnyk",
        avatar: "/images/ui/people/people-06.jpg"
      },
      message: {
        input: "What are you all on ??"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Emma Laurent",
        avatar: "/images/ui/people/people-02.jpg"
      },
      message: {
        input: "again sky the under",
        clear: "That's amazing, I hope you'll post some photos"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Ethan Parker",
        avatar: "/images/ui/people/people-08.jpg"
      },
      message: {
        input: "water flag on red",
        clear: "How was the flight?"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Ruby Mihai",
        avatar: "/images/ui/people/people-04.jpg"
      },
      message: {
        input: "Did I miss something? Are you all drunk?"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Akemi Ito",
        avatar: "/images/ui/people/people-03.jpg"
      },
      message: {
        input: "white of orange bloom",
        clear: "いらっしゃいませ !"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Natan Peretz",
        avatar: "/images/ui/people/people-10.jpg"
      },
      message: {
        input: "Seems like I'm out of the loop once again..."
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }, {
      user: {
        name: "Benjamin Durand",
        avatar: "/images/ui/people/people-09.jpg"
      },
      message: {
        input: "yellow over in space",
        clear: "Lmao people without Lucid must think we're all crazy"
      },
      time: DateTime.now().minus({
        hours: 17
      }).toJSDate()
    }]);
    var index = ref(0);
    var displayed = computed(function () {
      return index.value === posts.value.length - 1 ? [posts.value[index.value], posts.value[0]] : posts.value.slice(index.value, index.value + maximum);
    });

    var animate = function animate() {
      index.value = index.value < posts.value.length - 1 ? index.value + 1 : 0;
      delay();
    };

    var delay = function delay() {
      var timer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : random(rate.max, rate.max);
      return setTimeout(function () {
        return animate();
      }, timer);
    };

    onMounted(function () {
      return delay(rate.max);
    });
    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_tab_pane = _resolveComponent("n-tab-pane");

      var _component_n_tabs = _resolveComponent("n-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(ShowcasePanel, {
        posts: _unref(displayed),
        class: "flex-fill"
      }, null, 8, ["posts"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(ShowcasePanel, {
        posts: _unref(displayed),
        clear: true,
        class: "flex-fill"
      }, null, 8, ["posts"])])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_n_text, {
        depth: 3
      }, {
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      })]), _createVNode(_component_n_tabs, {
        type: "segment",
        class: "mobile-tabs"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_tab_pane, {
            name: "regular",
            tab: "Standard user"
          }, {
            default: _withCtx(function () {
              return [_createVNode(ShowcasePanel, {
                posts: _unref(displayed)
              }, null, 8, ["posts"])];
            }),
            _: 1
          }), _createVNode(_component_n_tab_pane, {
            name: "lucid",
            tab: "Lucid user"
          }, {
            default: _withCtx(function () {
              return [_createVNode(ShowcasePanel, {
                posts: _unref(displayed),
                clear: true
              }, null, 8, ["posts"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])]);
    };
  }
});